import type { FeatureKey } from "~/types/subscription";

export const ROUTES = {
  main: {
    path: "/",
    createURL: () => ROUTES.main.path,
  },
  new: {
    path: "/new",
    createURL: () => ROUTES.new.path,
  },
  endingSoon: {
    path: "/ending_soon",
    createURL: () => ROUTES.endingSoon.path,
  },
  trending: {
    path: "/trending",
    createURL: () => ROUTES.trending.path,
  },
  breaking: {
    path: "/breaking",
    createURL: () => ROUTES.breaking.path,
  },
  binary: {
    path: "/binary",
    createURL: () => ROUTES.binary.path,
  },
  multiOutcome: {
    path: "/multi-outcome",
    createURL: () => ROUTES.multiOutcome.path,
  },
  umaDisputed: {
    path: "/uma-disputed",
    createURL: () => ROUTES.umaDisputed.path,
  },
  aggregated: {
    path: "/aggregated",
    createURL: () => ROUTES.aggregated.path,
  },
  activity: {
    path: "/activity",
    createURL: () => ROUTES.activity.path,
  },
  search: {
    path: "/search",
    createURL: (queryString?: string) =>
      `${ROUTES.search.path}${queryString ? `?${queryString}` : ""}`,
  },
  searchEntity: {
    path: "/predictions/:slug",
    createURL: (slug: string) =>
      `${ROUTES.searchEntity.path.replace(":slug", slug.toString())}`,
  },
  event: {
    path: "/event/:slug",
    createURL: (slug: string, marketId?: string) => {
      const path = ROUTES.event.path.replace(":slug", slug.toString());
      if (!marketId) return path;
      const search = new URLSearchParams({ market: marketId }).toString();
      return `${path}?${search}`;
    },
  },
  embed: {
    path: "/embed",
    createURL: (queryString?: string) =>
      `${ROUTES.embed.path}${queryString ? `?${queryString}` : ""}`,
  },
  category: {
    path: "/category/:slug",
    createURL: (slug: string) =>
      `${ROUTES.category.path.replace(":slug", slug.toString())}`,
  },
  privacyPolicy: {
    path: "/privacy",
    createURL: () => ROUTES.privacyPolicy.path,
  },
  termsOfUse: {
    path: "/terms",
    createURL: () => ROUTES.termsOfUse.path,
  },
  disclaimer: {
    path: "/disclaimer",
    createURL: () => ROUTES.disclaimer.path,
  },
  data: {
    path: "/data",
    createURL: () => ROUTES.data.path,
  },
  pricing: {
    path: "/pricing",
    createURL: (featureKey?: FeatureKey) => {
      const searchParams = new URLSearchParams();

      if (featureKey) {
        searchParams.set("feature", featureKey);
      }

      const queryString = searchParams.toString();

      return `${ROUTES.pricing.path}${queryString ? `?${queryString}` : ""}`;
    },
  },
  howItWorks: {
    path: "/how-it-works",
    createURL: () => ROUTES.howItWorks.path,
  },
  dashboards: {
    path: "/dashboards",
    createURL: () => ROUTES.dashboards.path,
  },
  highlights: {
    path: "/dashboards/highlights",
    createURL: () => ROUTES.highlights.path,
  },
  worldCup: {
    path: "/dashboards/fifa-2026-world-cup",
    createURL: () => ROUTES.worldCup.path,
  },
  insights: {
    path: "/insights",
    createURL: () => ROUTES.insights.path,
  },
  insight: {
    path: "/insights/:slug",
    createURL: (slug: string) =>
      `${ROUTES.insight.path.replace(":slug", slug.toString())}`,
  },
  insightsAll: {
    path: "/insights/all",
    createURL: () => ROUTES.insightsAll.path,
  },
  insightsCategory: {
    path: "/insights/category/:slug",
    createURL: (slug: string) =>
      ROUTES.insightsCategory.path.replace(":slug", slug.toString()),
  },
  insightsType: {
    path: "/insights/type/:slug",
    createURL: (slug: string) =>
      ROUTES.insightsType.path.replace(":slug", slug.toString()),
  },
  insightsTag: {
    path: "/insights/tag/:slug",
    createURL: (slug: string) =>
      ROUTES.insightsTag.path.replace(":slug", slug.toString()),
  },
  insightDraft: {
    path: "/insights/draft/:slug",
    createURL: (slug: string) =>
      ROUTES.insightDraft.path.replace(":slug", slug.toString()),
  },
  warIndex: {
    path: "/indices/war",
    createURL: () => ROUTES.warIndex.path,
  },
};
